<template>
  <BaseSlideOverModal
    v-model:is-modal-open="localOpen"
    width="2xl"
    :title="$trans(element?.title)"
    @close="close"
  >
    <template #cta>
      <div class="mt-1 flex h-full gap-x-1">
        <BaseButton
          :title="'save'"
          icon="paper-plane"
          size="small"
          :disabled="invalidForm"
          color="primary"
          @click="submitForm"
        />
      </div>
    </template>
    <template #body>
      <form
        class="-mx-0.5 flex w-full flex-col gap-y-5 overflow-y-auto px-0.5"
        @submit.prevent="submitForm"
      >
        <div v-if="element" class="grid grid-cols-2 gap-3">
          <div class="col-span-2">
            <BaseShowEditTranslation
              v-model:translations="element.title"
              :label="$t('attributes.title')"
              name="title"
              :edition-mode="true"
              :required="true"
            />
          </div>

          <div class="col-span-2">
            <SelectComponent
              v-model="element.stat_type"
              :label="$t('attributes.stat_type')"
              :name="'stat_type'"
              :values="getStatTypeByTypeRow"
              :required="true"
            />
          </div>
        </div>

        <template v-if="element?.stat_type">
          <div v-if="type === 'large'" class="grid grid-cols-2 gap-3">
            <button
              v-for="chartType in chartTypeList"
              :key="chartType?.id"
              type="button"
              class="col-span-1 flex flex-row items-center gap-2 rounded-lg border p-3"
              :class="[
                chartType.id === element.chart_type
                  ? 'border-slate-300 shadow-sm'
                  : 'border-gray-200 text-gray-500'
              ]"
              @click="() => handleSelectChartType(chartType?.id)"
            >
              <span class="w-1/3">
                <img
                  :alt="chartType?.name"
                  :src="svg[chartType?.id]"
                  :class="[
                    chartType.id === element.chart_type
                      ? ''
                      : 'grayscale filter'
                  ]"
                />
              </span>
              <span class="w-2/3 text-lg font-bold">{{ chartType?.name }}</span>
            </button>
          </div>
          <template
            v-if="
              (type === 'large' && element?.chart_type) || type === 'simple'
            "
          >
            <div class="grid grid-cols-1">
              <div
                class="grid grid-rows-1 rounded-md border border-slate-300 p-2"
              >
                <div class="mb-2 border-b border-slate-300 pb-2">
                  <BaseCheckBox
                    v-model="element.custom_filters"
                    :label="$t('global.add_custom_filters_for_this_stat')"
                    :class="'mb-0 capitalize'"
                    :edition-mode="true"
                  />
                </div>
                <div v-if="element.custom_filters">
                  <FilterLinesComponent
                    v-model:filters="element.filters"
                    :is-element-modal="true"
                    :filters-available="availableFilter"
                  />
                </div>
                <div v-if="element.stat_type === 'sales_turnover'">
                  <BaseCheckBoxGroup
                    v-model:options-selected="element.filters_sales_turnover"
                    :options="filterAnalyticSalesTurnovers"
                    :default-values="stats_periods"
                    :name="'sales_turnover_type'"
                    :with-label="true"
                    :grid-cols="2"
                    :with-submit-button="false"
                  />
                </div>
              </div>
              <div v-if="type === 'large'" class="col-span-2">
                <!--                Détaillé part plutot que groupé part-->
                <SelectComponent
                  v-model="element.group_by"
                  :label="$t('attributes.group_by')"
                  :name="'group_by'"
                  :values="groupByList"
                  :required="true"
                />
                <SelectComponent
                  v-if="
                    element.group_by === 'periode' &&
                    [
                      'sales_turnover',
                      'dossier_count',
                      'burial_count',
                      'cremation_count'
                    ].includes(element?.stat_type)
                  "
                  v-model="element.group_by_value"
                  :label="$t('attributes.periode')"
                  :name="'group_by_value'"
                  :values="groupByValue"
                  :required="true"
                />
              </div>
              <!--              <div class="col-span-2">-->
              <!--                <SelectComponent-->
              <!--                  v-model="localElement.comparaison"-->
              <!--                  :label="$t('attributes.comparaison')"-->
              <!--                  :name="'comparaison'"-->
              <!--                  :values="comparaisonList"-->
              <!--                  :required="true"-->
              <!--                />-->
              <!--              </div>-->
            </div>
          </template>
        </template>

        <template v-if="type === 'large'">
          <div class="grid grid-cols-2 gap-3">
            <h2 class="col-span-2 mt-2 text-lg leading-none font-bold">
              {{ $t('global.options') }}
            </h2>
            <div class="col-span-2">
              <SelectComponent
                v-model="element.format"
                :label="$t('global.format')"
                :name="'format'"
                :values="[
                  {
                    id: 'compact',
                    name: $t('button.shrink')
                  },
                  {
                    id: 'extended',
                    name: $t('button.expand')
                  }
                ]"
              />
            </div>

            <div class="col-span-2">
              <!--              <SelectComponent-->
              <!--                v-model="element.default_view"-->
              <!--                :label="$t('attributes.default_view')"-->
              <!--                :name="'default_view'"-->
              <!--                :values="[-->
              <!--                  {-->
              <!--                    id: 'data',-->
              <!--                    name: $t('global.data_table')-->
              <!--                  },-->
              <!--                  {-->
              <!--                    id: 'chart',-->
              <!--                    name: $t('global.chart')-->
              <!--                  }-->
              <!--                ]"-->
              <!--              />-->
            </div>
          </div>
        </template>
      </form>
    </template>
  </BaseSlideOverModal>
</template>

<script>
import { mapGetters } from 'vuex'
import BaseSlideOverModal from '@c/addf-package/components/modal/BaseSlideOverModal.vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent.vue'
import BaseShowEditTranslation from '@c/addf-package/components/BaseShowEditInput/BaseShowEditTranslation.vue'

import svgLine from '@/assets/images/chart_type/line.svg'
import svgPie from '@/assets/images/chart_type/pie.svg'
import svgDoughnut from '@/assets/images/chart_type/doughnut.svg'
import svgBar from '@/assets/images/chart_type/bar.svg'
import BaseButton from '@c/addf-package/components/BaseButton/BaseButton.vue'
import BaseShowEditDatePickerv2 from '@c/addf-package/components/BaseShowEditDatePicker/BaseShowEditDatePickerv2.vue'
import BaseCheckBox from '@c/addf-package/components/BaseCheckBox/BaseCheckBox.vue'
import DashboardPanelControl from '@c/Dashboard/Components/DashboardPanelControl.vue'
import FilterLinesComponent from '@c/Dashboard/Components/FilterLinesComponent.vue'
import BaseCheckBoxGroup from '@c/BaseCheckBoxGroup.vue'

export default {
  name: 'ElementModal',
  components: {
    BaseCheckBoxGroup,
    FilterLinesComponent,
    DashboardPanelControl,
    BaseCheckBox,
    BaseShowEditDatePickerv2,
    BaseButton,
    BaseShowEditTranslation,
    SelectComponent,
    BaseSlideOverModal
  },
  props: {
    open: {
      type: Boolean,
      required: true
    },
    type: {
      type: String,
      required: true
    },
    element: {
      type: Object,
      required: true
    },
    filters: {
      type: Array,
      required: true
    }
  },
  emits: ['close', 'save-dashboard', 'update:element', 'update:open'],
  data() {
    return {
      localElement: { ...this?.element, title: { ...this?.element?.title } },
      svg: {
        line: svgLine,
        pie: svgPie,
        doughnut: svgDoughnut,
        bar: svgBar
      },
      useCustomFilters: false,
      emptyFilters: false,
      invalidForm: true
    }
  },
  computed: {
    ...mapGetters({
      auth: 'auth/getAuth',
      stats_types: 'metadata/getStatsTypes',
      chart_types: 'metadata/getChartTypes',
      stats_periods: 'metadata/getStatsPeriods',
      filterAnalyticSalesTurnovers: 'metadata/getFilterAnalyticsSalesTurnover',
      availableFilter: 'metadata/getAvailableFilterAnalytics'
    }),
    localOpen: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    },
    getStatTypeByTypeRow() {
      return this?.stats_types.filter((item) =>
        item?.rows_types.includes(this.type)
      )
    },
    chartTypeList() {
      if (!this?.element?.stat_type) {
        return []
      }

      return this.chart_types?.filter((item) =>
        this.stats_types
          .find((item) => item.id === this?.element?.stat_type)
          .charts_types.includes(item.id)
      )
    },
    groupByList() {
      let baseFilter = [
        { id: 'funeral_home', name: this.$t('attributes.funeral_home') }
      ]

      const additionalFilters = {
        sales_turnover: [
          { id: 'periode', name: this.$t('attributes.periode') },
          { id: 'company', name: this.$t('attributes.company') }
        ],
        dossier_count: [
          { id: 'company', name: this.$t('attributes.company') },
          { id: 'periode', name: this.$t('attributes.periode') }
        ],
        cremation_count: [
          { id: 'company', name: this.$t('attributes.company') },
          { id: 'periode', name: this.$t('attributes.periode') }
        ],
        burial_count: [
          { id: 'company', name: this.$t('attributes.company') },
          { id: 'periode', name: this.$t('attributes.periode') }
        ]
      }

      const filtersToAdd = additionalFilters[this?.element?.stat_type] || []
      baseFilter = [...baseFilter, ...filtersToAdd]
      return baseFilter.filter((item) =>
        this.stats_types
          .find((item) => item?.id === this?.element?.stat_type)
          .group_by_types.includes(item.id)
      )
    },
    groupByValue() {
      if (this.element.group_by === 'periode') {
        return [
          {
            id: 'days',
            name: this.$t('attributes.days')
          },
          {
            id: 'week',
            name: this.$t('global.weeks')
          },
          {
            id: 'month',
            name: this.$t('attributes.month')
          },
          {
            id: 'year',
            name: this.$t('attributes.year')
          }
        ]
      }
    },

    comparaisonList() {
      return [
        {
          id: 'funeral_home',
          name: this.$t('attributes.funeral_home')
        },
        {
          id: 'periode',
          name: this.$t('attributes.periode')
        }
      ].filter(
        (filter_item) =>
          this.stats_types
            .find((find_item) => find_item.id === this?.element?.stat_type)
            .comparaison_types.includes(filter_item.id) &&
          this?.element?.group_by !== filter_item.id
      )
    }
  },

  watch: {
    element: {
      handler(newValue, _oldValue) {
        this.$emit('update:element', newValue)
        this.invalidForm = !(
          ((this?.element?.filters &&
            this?.element?.filters?.length !== 0 &&
            this?.element?.custom_filters) ||
            !this?.element.custom_filters) &&
          Object.keys(this?.element?.title).length !== 0
        )
      },
      deep: true
    }
  },
  mounted() {
    if (this?.filters) {
      this.element.filters = JSON.parse(JSON.stringify(this.filters))
      this.$emit('update:element', this.element)
    }
  },
  methods: {
    handleSelectChartType(chart_type) {
      this.element.chart_type = chart_type
    },
    submitForm() {
      if (this?.element?.filters && this?.element?.filters.length >= 1) {
        if (
          Object.keys(
            this?.element?.filters[this?.element?.filters?.length - 1]
          ).some((key) => {
            return (
              this?.element?.filters[this?.element?.filters?.length - 1][
                key
              ] === null
            )
          })
        ) {
          // this.$h.toastWarning('Filters need to be completely filled')
          return false
        }
      }
      this.$emit('update:element', this.element)
      this.$emit('save-dashboard')
      this.$h.toastSuccess('element_saved')
      this.close()
    },
    close() {
      this.$emit('close')
    }
  }
}
</script>
